import { TestResultDataType } from "../Common/Testing/TestResultDataType";
import { ExpressionConfiguration } from "./ExpressionConfiguration";
import { BaseTestResultItem } from "../Common/Testing/BaseTestResultItem";
import { BaseTestResultData } from "../Common/Testing/BaseTestResultData";

export class ExpressionTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.EXPRESSION;
    expression: ExpressionConfiguration;

    constructor(itemId: string, result: string | undefined, expression: ExpressionConfiguration) {
        super(itemId, result);
        this.expression = expression;
    }
}

export class ExpressionElementTestResult extends BaseTestResultItem {
    type: TestResultDataType = TestResultDataType.EXPRESSION_ELEMENT;
}

export class ExpressionValueTestResult extends BaseTestResultItem {
    type: TestResultDataType = TestResultDataType.EXPRESSION_VALUE;
}
